export default "__VITE_ASSET__CM76Vx5w__"